var map = {
	"./modules/inventory/inventory.module": [
		"./src/app/modules/inventory/inventory.module.ts",
		"modules-inventory-inventory-module"
	],
	"./modules/monitoring/monitoring.module": [
		"./src/app/modules/monitoring/monitoring.module.ts",
		"modules-monitoring-monitoring-module"
	],
	"./modules/platform-setup/platform-setup.module": [
		"./src/app/modules/platform-setup/platform-setup.module.ts",
		"modules-platform-setup-platform-setup-module"
	],
	"./modules/reports/reports.module": [
		"./src/app/modules/reports/reports.module.ts",
		"modules-reports-reports-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;